
/*
 * VNCmail : A whole new experience in enterprise email communication.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef, inject } from "@angular/core";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { getActiveProfile, getAllContacts, getOnlineStatus, getUserProfile, RootState } from "src/app/reducers";
import { Store } from "@ngrx/store";
import { getContactById } from "../../../reducers/index";
import { CommonUtil } from "../../../common/utils/common.utils";
import { ConfigService } from "src/app/common/providers/config.service";
import { switchMap, takeUntil, filter, take, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { Subject, of } from "rxjs";
// import { MailUtils } from "src/app/mail/utils/mail-utils";
import { ElectronService } from "src/app/task/services/electron.service";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { SetActiveProfile, SetRightSidebarStatus,
  // SetRightSidebarStatus
 } from "src/app/actions/app";
// import { ToastService } from "src/app/common/providers/toast.service";
import { TaskRepository } from "src/app/task/repository/task.repository";
import { UserProfile } from "../../models";
import { RandomColor } from "src/app/common/utils/random-color";
import { TaskService } from "src/app/task/task.service";
import { DatabaseService } from "../../services/database.service";
import { getAuthUser, SetIsLoading } from "../../store";
import { AppConstants } from "src/app/common/utils/app-constants";
import { TaskImageCropperDialogComponent } from "../task-image-cropper-dialog/task-image-cropper-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { Broadcaster } from "src/app/common/providers/broadcaster.service";
import { SuccessService } from "src/app/common/providers/success-service";
import { SuccessType } from "../../shared/task-enum";
import { VncLibraryService, VNCHeaderComponent, ProfileComponent, VNCInputComponent, VNCChipsComponent } from "@uxf/vnc-library";
import { TaskImageDesktopCropperComponent } from "../task-image-desktop-cropper/task-image-desktop-cropper";
import { LocaleDatePipe } from "../pipes/locale-date.pipe";
import { LocaleService } from "../../../common/providers/locale.service";
import { UntypedFormControl } from "@angular/forms";
import { MatFabButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { UserAvatarComponent } from "../../../shared/components/user-avtar/user-avatar.component";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { NgTemplateOutlet } from "@angular/common";
import { MatDivider } from "@angular/material/divider";
import { StorageService } from "../../../common/services/storage.service";


@Component({
    selector: "vp-right-sidebar",
    templateUrl: "./right-sidebar.component.html",
    styleUrls: [
        "./right-sidebar.component.scss"
    ],
    imports: [VNCHeaderComponent, MatFabButton, MatTooltip, UserAvatarComponent, ProfileComponent, VNCInputComponent, VNCChipsComponent, MatTabGroup, MatTab, NgTemplateOutlet, MatDivider, TranslatePipe]
})
export class RightSidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  private localeService = inject(LocaleService);
  private vncLibaryService = inject(VncLibraryService);
  private successService = inject(SuccessService);
  private broadcaster = inject(Broadcaster);
  private matDialog = inject(MatDialog);
  private databaseService = inject(DatabaseService);
  private breakpointObserver = inject(BreakpointObserver);
  private electronService = inject(ElectronService);
  private taskService = inject(TaskService);
  private store = inject<Store<RootState>>(Store);
  private taskRepository = inject(TaskRepository);
  private translate = inject(TranslateService);
  private config = inject(ConfigService);
  private changerDetectorRef = inject(ChangeDetectorRef);

  /** userId -> object URL for the fetched avatar; "" while a fetch is in flight (AUTH-09). */
  private avatarObjectUrls: { [userId: string]: string } = {};

  private datePipe: LocaleDatePipe = new LocaleDatePipe(this.localeService);
  isMobileDevice : boolean = false;
  avatarUser: any;
  avatarVisible = true;
  avatarUrl: string = "";
  contact: any;
  translations: any = {};
  private isAlive$ = new Subject<boolean>();
  isLargeScreen: boolean;
  currentUser: any;
  isLoggedInUser: any;
  supportedApps = ["talk", "mail", "task"];
  searchParams: any = {
    q: "test",
    sort: "created_dt desc",
    start: 0,
    apps: this.supportedApps.join(","),
    limit: 20
  };
  searchResponse: any = { docs: [], loading: false };
  activeEmail: string;
  isOnline: any;

  loggedInUserJid:string = "";
  searchControl: UntypedFormControl;

  constructor() {
      this.searchControl = new UntypedFormControl("", []);
    this.isLargeScreen = this.breakpointObserver.isMatched("(min-width: 1480px)");
    this.breakpointObserver
      .observe("(min-width: 1480px)").pipe(takeUntil(this.isAlive$))
      .subscribe((state: BreakpointState) => {
        this.isLargeScreen = state.matches;
        this.changerDetectorRef.markForCheck();
      });
      this.config.currentLanguage.subscribe((lang: any) => {
        this.translate.reloadLang(lang).subscribe(v => {
            this.translations = v;
            this.changerDetectorRef.markForCheck();
        });
      });

    this.store.select(getOnlineStatus).pipe(takeUntil(this.isAlive$)).subscribe((isOnline) => {
      this.isOnline = isOnline;
      this.changerDetectorRef.markForCheck();
    });


    this.searchControl.valueChanges.pipe(debounceTime(300)
      , distinctUntilChanged(), takeUntil(this.isAlive$)).subscribe(async (keyword) => {
        console.log("searchControl", this.activeIndex, keyword);
        let apps = ["talk", "mail"];
        if (this.activeIndex === 1) {
          apps = ["talk"];
        } else if (this.activeIndex === 2) {
          apps = ["mail"];
        }

        this.callSearchActivity(this.prevData);
      });
  }

  ngOnInit(): void {

    this.store.select(getAuthUser).pipe(filter(Boolean), takeUntil(this.isAlive$)).subscribe(user => {
      this.currentUser = user;
      //////console.log("currentUser user", user);
      this.changerDetectorRef.markForCheck();
    });
     this.store.select(getUserProfile).pipe(take(1)).subscribe(user => {
       if (user) {
         this.loggedInUserJid = user.email;
       }
     });
    this.store.select(getActiveProfile).pipe(switchMap(email => {
      ////console.log("getActiveProfile", email)
      this.activeEmail = email;
      this.searchResponse = { docs: [], loading: false };
      if (!!email) {
        this.contact = {
          email: this.activeEmail,
          first_name: this.activeEmail.split("@")[0]
        };
        if (!this.contact.jid) {
          this.contact.jid = this.contact.email;
        }
        this.contact.firstLastCharacters = CommonUtil.getCharacters(this.activeEmail.split("@")[0], "");
        this.callSearchActivity(this.prevData);
        if (this.isOnline) {
          if (this.currentUser.email === email) {
            return this.taskService.getLoggedInUserContactInfo(this.currentUser.email);
          }
          if (this.currentUser.email !== email && email) {
            return this.taskService.getContactInfo(email);
          }
        } else {
          return this.databaseService.getContactInfo(this.currentUser.email);
        }
      } else {
        this.contact = {};
        return of(null);
      }
    }), takeUntil(this.isAlive$)).subscribe((contact: any) => {
      if (!!contact) {
        if (!contact.email && contact.jid) {
          contact.email = contact.jid;
        } else if (!contact.email && contact.emails) {
          contact.email = contact.emails[0].email;
        }
        if (this.currentUser && contact.email === this.currentUser.email) {
          contact.user_id = this.currentUser.id;
          contact.avatar = this.currentUser.userAvatar;
        }
        if (!this.contact.jid) {
          this.contact.jid = this.contact.email;
        }
        this.contact = contact;
        this.callSearchActivity(this.prevData);
        if (contact.first_name) {
          this.contact.firstLastCharacters = CommonUtil.getCharacters(contact.first_name, contact.last_name);
        }
      }
      this.changerDetectorRef.markForCheck();
    });
    this.broadcaster.on<any>("profileAvatarUpdatedLocal")
      .pipe(takeUntil(this.isAlive$))
      .subscribe(data => {
        if (data?.jid === this.contact?.jid) {
          this.contact.avatar = data.avatar;
          this.changerDetectorRef.markForCheck();
        }
      });
    this.successService.only(SuccessType.UserAvatarUpdated)
      .pipe(takeUntil(this.isAlive$))
      .subscribe(success => {
        this.taskService.getContactInfo(this.contact.email).subscribe(contact => {
          this.contact.avatar = contact.avatar;
          this.changerDetectorRef.markForCheck();
        });
        this.store.dispatch(new SetIsLoading(false));
        this.vncLibaryService.openSnackBar(success.messages, "", "", "", 3000, "bottom", "left").subscribe(res => {
        });
        this.broadcaster.broadcast("profileAvatarUpdated");
      });
    if (!this.translations || Object.keys(this.translations)?.length === 0) {
      const lang = this.config?.languageTemp || StorageService.getLocalItem(AppConstants.TASK_LANGUAGE);;
      this.translate.reloadLang(lang).subscribe(v => {
        this.translations = v;
        this.changerDetectorRef.markForCheck();
      });
    }
    this.isMobileDevice = this.breakpointObserver.isMatched("(max-width: 767px)");
    this.breakpointObserver.observe(["(max-width: 767px)"]).pipe(takeUntil(this.isAlive$)).subscribe((state: BreakpointState) => {
        if (state.matches) {
        this.isMobileDevice = true;
        } else {
        this.isMobileDevice = false;
        }
        this.changerDetectorRef.markForCheck();
    });
  }

  getBgAvatarColor(jid) {
    return RandomColor.getCharColor(jid);
  }

  // getAvatarUrl(jid) {
  //   return this.contact.avatar;
  // }

  /**
   * Called from the template, so it must stay synchronous and cheap. The avatar is
   * fetched once with the Authorization header and cached as an object URL (AUTH-09);
   * until it arrives the binding is empty and vp-avatar shows its initials fallback.
   */
  getAvatarURL(userId) {
    if (!userId) {
      return "";
    }

    const cached = this.avatarObjectUrls[userId];
    if (cached !== undefined) {
      return cached;
    }

    // Mark as in-flight before subscribing so change detection cannot queue the same
    // request repeatedly while it is running.
    this.avatarObjectUrls[userId] = "";
    this.taskService.getAuthenticatedObjectUrl(this.taskService.getAvatarURL(userId))
      .pipe(takeUntil(this.isAlive$))
      .subscribe(objectUrl => {
        this.avatarObjectUrls[userId] = objectUrl;
        this.changerDetectorRef.markForCheck();
      }, () => {
        // Leave the empty string in place: the fallback renders and we do not retry on
        // every change-detection pass.
      });

    return "";
  }

  get fullName(): string {
    return (this.contact.first_name || this.contact.last_name) ? [this.contact.first_name, this.contact.last_name].filter(v => !!v).join(" ") : this.contact?.fullName;
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.isAlive$.next(false);
    this.isAlive$.complete();

    // Every fetched avatar holds a blob for the life of the document until revoked (OFF-08).
    Object.values(this.avatarObjectUrls).forEach(objectUrl => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    });
    this.avatarObjectUrls = {};
  }

  copyEmail(email: string) {
    // MailUtils.copyToClipboard([email]);
  }

  openURL(url: string) {
    if (typeof cordova !== "undefined") {
      if (device.platform === "iOS") {
        window.open(url, "_system");
      } else if (device.platform === "Android") {
        navigator.app.loadUrl(url, {
          openExternal: true
        });
      }
    } else if (this.electronService.isElectron) {
      this.electronService.openExternalUrl(url);
    } else {
      window.open(url, "_blank");
    }
  }

  closeSidebar() {
    this.store.dispatch(new SetRightSidebarStatus(false));
    this.store.dispatch(new SetActiveProfile(null));
  }

  handleProfileAction(action) {
    switch (action) {
      case "audio": this.startAudioCall(); break;
      case "video": this.startVideoCall(); break;
      case "chat": this.startChat(); break;
      case "mail": this.composeEmail(); break;
      case "ticket": this.createTicket(); break;
      case "task": this.createTask(); break;
    }
  }

  composeEmail(): void {
    this.taskRepository.sendEmail(this.contact.email);
  }

  createTask(): void {
    this.taskRepository.createTask(this.contact.username);
  }

  createTicket(): void {
    this.taskRepository.createTicket(this.contact.username);
  }

  startAudioCall(): void {
    if (this.isLoggedInUser) {
      // this.toastService.show("CAN_NOT_CALL_YOURSELF");
      return;
    }
    this.taskRepository.makeTalkAudioChatVideoOperation(this.contact.jid, "audio-call", "group-audio");
  }

  startVideoCall(): void {
    if (this.isLoggedInUser) {
      // this.toastService.show("CAN_NOT_CALL_YOURSELF");
      return;
    }
    this.taskRepository.makeTalkAudioChatVideoOperation(this.contact.jid, "video-call", "group-video");
  }

  startChat(): void {
    if (this.isLoggedInUser) {
      // this.toastService.show("CAN_NOT_CHAT_YOURSELF");
      return;
    }
    this.taskRepository.makeTalkAudioChatVideoOperation(this.contact.jid, "start-chat", "group-chat");
  }

  underDevelopment() {
    // this.toastService.show("COMING_SOON");
  }

  openRecentActivity(item) {
    if (item.type === "talk") {
      if (item.chatType === "chat") {
        this.taskRepository.jumpToChat(this.contact, item.talkId, item.createdDt);
      } else {
        this.underDevelopment();
      }
    } else if (item.type === "mail") {
      //console.log("openRecentActivity item: ", item);
      this.taskRepository.openMail(item.mailFolderID, item.id);
      this.closeSidebar();
    } else if (item.type === "task") {
      this.taskRepository.openTask(item.id);
    } else {
      this.underDevelopment();
    }
  }


  onSelectedTabChangeActivity(ev: any) {
    if (ev.index === 0) {
      this.callSearchActivity("talk,mail");
      this.prevData = "talk";
    } else if (ev.index === 1) {
      this.callSearchActivity("mail");
       this.prevData = "mail";
    }
  }

  activeIndex: number = 0;
  isActiveIndex(index: number) {
    this.activeIndex = index;
    if (index === 0) {
      this.callSearchActivity("talk,mail");
      this.prevData = "talk,mail";
    } else if (index === 1) {
      this.callSearchActivity("talk");
       this.prevData = "talk";
    } else if (index === 2) {
      this.callSearchActivity("mail");
       this.prevData = "mail";
    }
  }

  prevData = "talk,mail";
  callSearchActivity(apps: string): void {
    if (this.contact.jid || this.contact.emails && this.contact.emails.length > 0) {
      this.searchParams.from_s = (this.contact.jid) ? this.contact.jid : this.contact.emails[0].email;
      this.searchParams.apps = apps;
            if (!this.searchResponse) {
        this.searchResponse = {};
      }
      this.searchResponse.loading = true;
      if (this.searchParams.apps === "talk,mail") {
        this.searchParams.apps = "talk";
        this.taskRepository.searchDocs(this.searchParams, this.searchControl.value).subscribe(talk => {
        this.searchParams.apps = "mail";
          this.taskRepository.searchDocs(this.searchParams, this.searchControl.value).subscribe(mail => {
            if (talk && talk?.length > 0 && mail && mail?.length > 0) {
              this.searchResponse.docs = [...talk, ...mail];
            }
            if (talk && talk?.length > 0 && (!mail || mail.length === 0)) {
              this.searchResponse.docs = talk;
            }
            if (mail && mail?.length > 0 && (!talk || talk?.length === 0)) {
              this.searchResponse.docs = mail;
            }
            this.searchResponse.docs.sort((a, b) => {
              return new Date(b?.createdDt).getTime() - new Date(a?.createdDt).getTime();
            });
            this.ticketMention();
            this.searchResponse.loading = false;
            this.changerDetectorRef.markForCheck();
          });
        });
      } else {
        this.taskRepository.searchDocs(this.searchParams, this.searchControl.value).subscribe(docs => {
          this.searchResponse.docs = docs;
          console.log("this.searchResponse", this.prevData, docs);
          this.ticketMention();
          this.searchResponse.loading = false;
          this.changerDetectorRef.markForCheck();
        });
      }
    } else {
      if (!this.searchResponse) {
        this.searchResponse = {};
      }
      this.searchResponse.docs = [];
      this.searchResponse.loading = false;
      this.changerDetectorRef.markForCheck();
    }
  }

  ticketMention(){
    let translations: any = {};
    this.translate.get(["TICKET_MENTION_RECEIVER_MESSAGE", "TICKET_MENTION_SENDER_MESSAGE", "META_TASK_MENTION_RECEIVER_MESSAGE", "META_TASK_MENTION_SENDER_MESSAGE"]).pipe(take(1)).subscribe(v => {
        translations = v;
    });
    this.searchResponse.docs.map(doc=>{
        let isTicketMention: boolean = false;
        const TICKET_MENTION = "ticket_mention";
        const META_TASK_MENTION = "meta_task_mention";
        isTicketMention = CommonUtil.parseRedmineMentions(TICKET_MENTION, doc.contentTxt).length > 0 || CommonUtil.parseRedmineMentions(META_TASK_MENTION, doc.contentTxt).length > 0;
        if (isTicketMention) {
          if (CommonUtil.parseRedmineMentions(TICKET_MENTION, doc.contentTxt).length > 0) {
            const textToReplace = CommonUtil.parseRedmineMentions(TICKET_MENTION, doc.contentTxt)[0];
            let userjid = textToReplace.split("#")[1];

            if (userjid === this.loggedInUserJid) {
              const mentionText = translations.TICKET_MENTION_SENDER_MESSAGE.replace("{{ receiver_name }}", this.fullName);
              doc.contentTxt = doc.contentTxt.replace(textToReplace, mentionText).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
              //console.log("user mention", doc.contentTxt);
            } else {
              let mentionText = translations.TICKET_MENTION_RECEIVER_MESSAGE.replace("{{ sender_name }}", this.fullName);
              doc.contentTxt = doc.contentTxt.replace(textToReplace, mentionText).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
              //console.log("user mention", doc.contentTxt);
            }
          } else if (CommonUtil.parseRedmineMentions(META_TASK_MENTION, doc.contentTxt).length > 0) {
            const textToReplace = CommonUtil.parseRedmineMentions(META_TASK_MENTION, doc.contentTxt)[0];
            let userjid = textToReplace.split("#")[1];
            let mentionText = translations.META_TASK_MENTION_RECEIVER_MESSAGE.replace("{{ sender_name }}", this.fullName);
            if (userjid != this.loggedInUserJid) {
              mentionText = translations.META_TASK_MENTION_SENDER_MESSAGE.replace("{{ receiver_name }}", this.fullName);
            }
            isTicketMention = true;
            doc.contentTxt = doc.contentTxt.replace(textToReplace, mentionText).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
          }
        }

      if (doc.talk_attachment_s != undefined) {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(doc.talk_attachment_s, "text/xml");

        // Extract values
        const fileType = xmlDoc.getElementsByTagName("fileType")[0]?.textContent;
        if (fileType) {
          if (CommonUtil.isImage(fileType)) {
            doc["fileType"] = "image";
          } else if (CommonUtil.isAudio(fileType)) {
            doc["fileType"] = "audio";
          } else if (CommonUtil.isVideo(fileType)) {
            doc["fileType"] = "video";
          } else {
            doc["fileType"] = "doc";
          }
        }

        console.log("fileType:", fileType, doc);

      }
    });

  }

  showFeatureUnderDevelopmentToast(): void {
    // this.toastService.show("FEATURE_NEXT_VERSION_LBL");
  }

  openCropperDialog() {
    if (this.isOnline) {
      if (!this.isMobileDevice) {
        this.matDialog.open(TaskImageDesktopCropperComponent, {
          maxWidth: "100%",
          autoFocus: false,
          height: "485px",
          width: "650px",
          panelClass: "vp-task-image-cropper-dialog",
        });
      } else {
        this.matDialog.open(TaskImageCropperDialogComponent, {
          maxWidth: "100%",
          autoFocus: false,
          panelClass: "vp-task-image-cropper-dialog",
        });
      }
    } else {
      this.broadcaster.broadcast("OFFLINE_CONNECTION", true);
    }
  }
  getDateWithFormat(date, format) {
    return this.datePipe.transform(date, format);
  }
}